"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Image = _interopRequireDefault(require("@rsuite/icon-font/lib/av/Image"));

// Generated by script, don't edit it please.
var Image = (0, _createSvgIcon["default"])({
  as: _Image["default"],
  ariaLabel: 'image',
  category: 'av',
  displayName: 'Image'
});
var _default = Image;
exports["default"] = _default;
module.exports = exports.default;